import React, { FunctionComponent } from 'react'
import { t } from 'ttag'
import { FormProps } from '../builders/form-builder'
import { useLocation } from '@reach/router'

const Form: FunctionComponent<FormProps> = ({ handleSubmit, sending, locale }) => {
    const location = useLocation()

    return (
        <>
            <div className={`sib-form ${sending ? 'sending' : ''}`}>
                <div id="sib-form-container" className="sib-form-container">
                    <div id="sib-container" className="sib-container--large sib-container--vertical">
                        <form id="sib-form" onSubmit={(e) => handleSubmit(e)} method="POST" action="https://5916dcc0.sibforms.com/serve/MUIEAAXPkYKCrGhQW6R8Qvk9Vguumh2REBhkCEyQprtdA5fI83ySQye3jRusI5M-txAhPK-Htl-eqPK3EzNfZg3hFlhRiXGMan0nh021NXKn7Vvx7aV4c0AH8yWSdDTPcYZIZecddfQztpKGN3_0mzlS6CDCDaHrcV5CuH6AUeNcyKIiuDsJABt-61nQEOvEL9eUkQjMXKbbCDBP">
                            <div className="sib-form-row">
                                <div className="sib-input sib-form-block">
                                    <div>
                                        <div className="form__entry entry_block">
                                            <div className="form__label-row ">
                                                <label className="entry__label" htmlFor="FIRSTNAME" data-required="*">
                                                    {t`PuxDesign.Form.Name`}
                                                </label>

                                                <div className="entry__field">
                                                    <input className="input" type="text" id="FIRSTNAME" name="FIRSTNAME" data-required="true" required />
                                                </div>
                                            </div>

                                            <label className="entry__error entry__error--primary">
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="form__entry entry_block">
                                            <div className="form__label-row ">
                                                <label className="entry__label" htmlFor="EMAIL" data-required="*">
                                                    {t`PuxDesign.Form.Mail`}
                                                </label>

                                                <div className="entry__field">
                                                    <input className="input" type="email" id="EMAIL" name="EMAIL" data-required="true" required />
                                                </div>
                                            </div>

                                            <label className="entry__error entry__error--primary">
                                            </label>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="form__entry entry_block">
                                            <div className="form__label-row ">
                                                <label className="entry__label" htmlFor="PHONE" data-required="*">
                                                    {t`PuxDesign.Form.Phone`}
                                                </label>

                                                <div className="entry__field">
                                                    <input className="input" type="text" id="PHONE" name="PHONE" data-required="true" required />
                                                </div>
                                            </div>

                                            <label className="entry__error entry__error--primary">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="sib-input sib-form-block">
                                    <div className="form__entry entry_block h-100">
                                        <div className="form__label-row h-100">
                                            <label className="entry__label" htmlFor="MESSAGE">
                                                {t`PuxDesign.Form.Message`}
                                            </label>

                                            <div className="entry__field h-100">
                                                <textarea className="input" id="MESSAGE" name="MESSAGE" ></textarea>
                                            </div>
                                        </div>

                                        <label className="entry__error entry__error--primary">
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="sib-form-block">
                                <button className="btn btn-big-monster sib-form-block__button sib-form-block__button-with-loader"
                                    form="sib-form" type="submit">
                                    <svg className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                                        <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
                                        />
                                    </svg>
                                    {t`PuxDesign.Form.Online.Button`}
                                </button>
                            </div>
                            <input type="text" name="email_address_check" value="" className="input--hidden" />
                            <input type="hidden" id="SOURCELINK" name="SOURCELINK" value={location.href} />
                            <input type="hidden" name="locale" value={locale} />
                            <input type="hidden" name="html_type" value="simple" />
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Form;